// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeliveryClassificationModal-module_body___QjD6v > div {
  gap: 1.2rem;
}

.DeliveryClassificationModal-module_buttons___tQSIk {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/deliveryClassification/DeliveryClassificationModal.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;AACD;;AAEA;EACC,aAAA;EACA,yBAAA;EACA,SAAA;AACD","sourcesContent":[".body > div {\r\n\tgap: 1.2rem;\r\n}\r\n\r\n.buttons {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n\tgap: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `DeliveryClassificationModal-module_body___QjD6v`,
	"buttons": `DeliveryClassificationModal-module_buttons___tQSIk`
};
export default ___CSS_LOADER_EXPORT___;
